/**
 * Breakpoints for `ember-media-query`. Note that these are the default
 * breakpoint values from the now deprecated `ember-responsive` addon.
 * See https://github.com/NAISorg/ember-media-query?tab=readme-ov-file#define-breakpoints
 */

export default {
  mobile: '(max-width: 767px)',
  /*
  tablet:  '(min-width: 768px) and (max-width: 991px)',
  desktop: '(min-width: 992px) and (max-width: 1200px)',
  jumbo:   '(min-width: 1201px)'
  */
};
